/**
 * Spec F (chat-proactive-greeting), Phase 12 — cached client timezone.
 *
 * The backend greeting producer (Phase 5) and `get_my_session_info` tool
 * (Phase 7.5) both read an `X-Client-Timezone` header carrying the IANA
 * zone the browser is running in. Computing it is cheap but we still cache
 * the value at module load so request interceptors don't re-resolve it on
 * every call.
 *
 * `Intl.DateTimeFormat().resolvedOptions().timeZone` is supported by every
 * browser Next.js 16 targets. On the server (SSR) the API is still present
 * via Node's ICU bundle, but the result is the server's timezone — not the
 * client's. We therefore return `null` during SSR and let the caller decide
 * how to handle it (the axios interceptor simply omits the header).
 */

let cached: string | null | undefined;

export function getClientTimezone(): string | null {
  if (cached !== undefined) return cached;
  if (typeof window === 'undefined') {
    cached = null;
    return cached;
  }
  try {
    cached = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    cached = null;
  }
  return cached;
}
